import {
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAIL,
  GET_BANNER_DETAILS,
  GET_BANNER_DETAILS_SUCCESS,
  GET_BANNER_DETAILS_FAIL,
  CREATE_BANNER,
  CREATE_BANNER_SUCCESS,
  CREATE_BANNER_FAIL,
  UPDATE_BANNER,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_FAIL,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_FAIL,
  DELETE_BANNER,

} from "./actionTypes"

// Banner - This line cannot be edited or removed
export const getBanners = (
  page,
  sort,
  limit,
  searchText,
  bannerId,

) => ({
  type: GET_BANNERS,
  payload: { page, sort,limit, searchText, bannerId,  },
})

export const getBannersSuccess = banners => ({
  type: GET_BANNERS_SUCCESS,
  payload: banners,
})

export const getBannersFail = error => ({
  type: GET_BANNERS_FAIL,
  payload: error,
})

export const getBannerDetails = bannerId => ({
  type: GET_BANNER_DETAILS,
  payload: bannerId,
})

export const getBannerDetailsSuccess = bannerDetails => ({
  type: GET_BANNER_DETAILS_SUCCESS,
  payload: bannerDetails,
})

export const getBannerDetailsFail = error => ({
  type: GET_BANNER_DETAILS_FAIL,
  payload: error,
})

export const createBanner = (banner, onCloseClick) => ({
  type: CREATE_BANNER,
  payload: { banner, onCloseClick },
})

export const createBannerSuccess = banner => ({
  type: CREATE_BANNER_SUCCESS,
  payload: banner,
})

export const createBannerFail = error => ({
  type: CREATE_BANNER_FAIL,
  payload: error,
})

export const getBannerDetail = bannerId => ({
  type: GET_BANNER_DETAILS,
  payload: bannerId,
})

export const updateBanner = (banner, bannerId, onCloseClick) => ({
  type: UPDATE_BANNER,
  payload: { banner, bannerId, onCloseClick },
})

export const updateBannerSuccess = banner => ({
  type: UPDATE_BANNER_SUCCESS,
  payload: banner,
})

export const updateBannerFail = error => ({
  type: UPDATE_BANNER_FAIL,
  payload: error,
})

export const deleteBanner = bannerId => ({
  type: DELETE_BANNER,
  payload: { bannerId },
})

export const deleteBannerSuccess = banner => ({
  type: DELETE_BANNER_SUCCESS,
  payload: banner,
})

export const deleteBannerFail = error => ({
  type: DELETE_BANNER_FAIL,
  payload: error,
})
